// extracted by mini-css-extract-plugin
export default {"cgrid":"GridView_cgrid__xYv9k","card":"GridView_card__Jo-LI","square_img":"GridView_square_img__nTsFf","title":"GridView_title__+53nF","subtitle":"GridView_subtitle__rELq6"};